var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.data, function(item, index) {
      return _c(
        "div",
        { key: `exemption-item-${index}`, staticClass: "mb-3" },
        [
          _c(
            "validation-observer",
            {
              ref: "validationRef",
              refInFor: true,
              attrs: { novalidate: "", tag: "form" }
            },
            [
              _c(
                "callout",
                {
                  attrs: {
                    "border-color": _vm.getStatusColor(item.statusId),
                    controlled: true,
                    "has-toggle": true,
                    opened: item.isOpen
                  },
                  on: {
                    "click:open": function($event) {
                      return _vm.onOpenDetails(index)
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "edition",
                        fn: function() {
                          return [
                            _c(
                              "custom-tab",
                              {
                                staticClass: "custom-tab-visit-details rounded"
                              },
                              [
                                _c(
                                  "custom-tab-item",
                                  {
                                    attrs: {
                                      active: item.tabIndex === 0,
                                      "content-class": "mt-3 pb-3",
                                      title: "Dispensa"
                                    },
                                    on: {
                                      click: function($event) {
                                        item.tabIndex = 0
                                      }
                                    }
                                  },
                                  [
                                    !item.isEditionMode &&
                                    !_vm.showAddEthicDocument
                                      ? _c(
                                          "div",
                                          { staticClass: "bg-gray p-2" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "bg-white rounded p-4"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "row" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-md-12 mb-3"
                                                      },
                                                      [
                                                        _c("em", {
                                                          staticClass:
                                                            "fas fa-info-circle text-orange mr-1"
                                                        }),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "color-gray-7 font-weight-bold font-16"
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Información Adicional Dispensa "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "col-md-12"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "data-name"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Comentario de Solicitud:"
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass: "data"
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item.exemptionRequestComment
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm.isDenyInformationVisible(
                                                  item.statusId
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "row mt-3"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-md-12 mb-3"
                                                          },
                                                          [
                                                            _c("em", {
                                                              staticClass:
                                                                "fas fa-info-circle text-orange mr-1"
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "color-gray-7 font-weight-bold font-16"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Información de Denegación "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-md-12"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "data-name"
                                                              },
                                                              [_vm._v("Razón:")]
                                                            ),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "data"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      item.exemptionDeterminationReasonName
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-md-12"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "data-name"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Comentario:"
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "data"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      item.denialComment
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    item.isEditionMode &&
                                    !_vm.showAddEthicDocument
                                      ? _c(
                                          "div",
                                          { staticClass: "bg-gray p-2" },
                                          [
                                            _vm.showLetterDocumentation
                                              ? _c("letter-documentation", {
                                                  on: {
                                                    "on-cancel": function(
                                                      $event
                                                    ) {
                                                      return _vm.cancelLetterHandler(
                                                        index
                                                      )
                                                    },
                                                    "on-save": function(
                                                      $event
                                                    ) {
                                                      return _vm.onApproveSave(
                                                        item,
                                                        $event
                                                      )
                                                    }
                                                  }
                                                })
                                              : _vm.showLetterAdd
                                              ? _c("letter-add", {
                                                  attrs: {
                                                    "educative-regions":
                                                      _vm.educativeRegions,
                                                    "secretary-name-txt":
                                                      item.secretaryName
                                                  },
                                                  on: {
                                                    "on-cancel": function(
                                                      $event
                                                    ) {
                                                      return _vm.cancelLetterHandler(
                                                        index
                                                      )
                                                    },
                                                    "on-save": function(
                                                      $event
                                                    ) {
                                                      return _vm.saveLetterHandler(
                                                        item,
                                                        $event
                                                      )
                                                    }
                                                  }
                                                })
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "bg-white rounded p-4"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "row mt-3"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-md-12 mb-3"
                                                          },
                                                          [
                                                            _c("em", {
                                                              staticClass:
                                                                "fas fa-flag text-orange mr-1"
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "color-gray-7 font-weight-bold font-16"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.statusTitle
                                                                    ) +
                                                                    " Dispensa "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        [
                                                          _vm.exemptionStatus
                                                            .PartiallyApproved,
                                                          _vm.exemptionStatus
                                                            .Denied
                                                        ].includes(
                                                          _vm.statusIdOpennedItem
                                                        )
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-md-12"
                                                              },
                                                              [
                                                                _c(
                                                                  "validation-provider",
                                                                  {
                                                                    attrs: {
                                                                      rules:
                                                                        "required"
                                                                    },
                                                                    scopedSlots: _vm._u(
                                                                      [
                                                                        {
                                                                          key:
                                                                            "default",
                                                                          fn: function({
                                                                            errors
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "custom-drop-down",
                                                                                {
                                                                                  attrs: {
                                                                                    id: `reason-${index}`,
                                                                                    "custom-error-msg":
                                                                                      "Favor seleccionar una razón.",
                                                                                    error:
                                                                                      errors[0],
                                                                                    fieldkey:
                                                                                      "id",
                                                                                    fieldname:
                                                                                      "name",
                                                                                    label:
                                                                                      "Razón:",
                                                                                    options:
                                                                                      _vm.reasons,
                                                                                    placeholder:
                                                                                      "Seleccione"
                                                                                  },
                                                                                  model: {
                                                                                    value:
                                                                                      _vm
                                                                                        .selectedItem
                                                                                        .reason,
                                                                                    callback: function(
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        _vm.selectedItem,
                                                                                        "reason",
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                    expression:
                                                                                      "selectedItem.reason"
                                                                                  }
                                                                                }
                                                                              )
                                                                            ]
                                                                          }
                                                                        }
                                                                      ],
                                                                      null,
                                                                      true
                                                                    )
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-md-12"
                                                          },
                                                          [
                                                            _c(
                                                              "validation-provider",
                                                              {
                                                                attrs: {
                                                                  rules:
                                                                    "required"
                                                                },
                                                                scopedSlots: _vm._u(
                                                                  [
                                                                    {
                                                                      key:
                                                                        "default",
                                                                      fn: function({
                                                                        errors
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "custom-text-area",
                                                                            {
                                                                              attrs: {
                                                                                id: `comment-${index}`,
                                                                                "custom-error-msg":
                                                                                  "Favor escribir un comentario.",
                                                                                error:
                                                                                  errors[0],
                                                                                label:
                                                                                  "Comentario:",
                                                                                maxlength: 3000,
                                                                                name:
                                                                                  "comment",
                                                                                rows: 3,
                                                                                "show-char-count": true
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  _vm
                                                                                    .selectedItem
                                                                                    .comment,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.selectedItem,
                                                                                    "comment",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                                expression:
                                                                                  "selectedItem.comment"
                                                                              }
                                                                            }
                                                                          )
                                                                        ]
                                                                      }
                                                                    }
                                                                  ],
                                                                  null,
                                                                  true
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-md-12"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex justify-content-end align-items-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "action-button",
                                                                  {
                                                                    attrs: {
                                                                      id:
                                                                        "modal-btn-cancelar",
                                                                      i:
                                                                        "fas fa-times-circle",
                                                                      variant:
                                                                        "outline-danger mr-2"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.cancel(
                                                                          index
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Cancelar "
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "action-button",
                                                                  {
                                                                    attrs: {
                                                                      i:
                                                                        "fa fa-save",
                                                                      variant:
                                                                        "success pl-4 pr-4"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.saveItemDispensa(
                                                                          index,
                                                                          item
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Guardar "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.showAddEthicDocument
                                      ? _c(
                                          "div",
                                          { staticClass: "bg-gray p-2" },
                                          [
                                            _c("add-ethic-letter", {
                                              attrs: {
                                                "exemption-request-id":
                                                  item.exemptionRequestId
                                              },
                                              on: {
                                                "on-cancel": function($event) {
                                                  return _vm.cancel(index)
                                                },
                                                "on-refresh": function($event) {
                                                  return _vm.refreshResult()
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _c(
                                  "custom-tab-item",
                                  {
                                    attrs: {
                                      active: item.tabIndex === 1,
                                      "content-class": "mt-3 pb-3",
                                      title: "Historial"
                                    },
                                    on: {
                                      click: function($event) {
                                        item.tabIndex = 1
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "time-line",
                                      { staticClass: "m-4" },
                                      _vm._l(
                                        item.statusHistory.filter(
                                          (_, pos) =>
                                            pos <= item.historySize - 1
                                        ),
                                        function(historyItem, index) {
                                          return _c(
                                            "time-line-item",
                                            {
                                              key: `billing_history_list_${index}`,
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "date",
                                                    fn: function() {
                                                      return [
                                                        _c("ballon", {
                                                          staticClass:
                                                            "mt-2 p-0 font-weight-bold font-16",
                                                          attrs: {
                                                            "background-color": `text-center font-14 border-none bg-${_vm.getStatusColor(
                                                              historyItem.statusId
                                                            )}`,
                                                            text:
                                                              historyItem.statusName
                                                          }
                                                        }),
                                                        _c("div", [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "color-black font-16 font-weight-bold text-center"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$formatDate(
                                                                      historyItem.date,
                                                                      _vm
                                                                        .$templateDate
                                                                        .longDateWithHour
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ])
                                                      ]
                                                    },
                                                    proxy: true
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "row",
                                                  attrs: { id: "main-info" }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col mt-3 mt-md-0 mt-sm-3"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "color-secondary-6 font-14"
                                                        },
                                                        [_vm._v(" Usuario: ")]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "color-black font-16 font-weight-normal"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                historyItem.userEmail
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col mt-3 mt-md-0 mt-sm-3"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "color-secondary-6 font-14"
                                                        },
                                                        [_vm._v(" Nombre: ")]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "color-black font-16 font-weight-normal"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                historyItem.userName
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              historyItem.reasonComment
                                                ? _c(
                                                    "div",
                                                    { staticClass: "pt-3" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "bg-white p-2 rounded"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass: "row"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col"
                                                                },
                                                                [
                                                                  _c("em", {
                                                                    staticClass:
                                                                      "fas fa-info-circle color-orange mr-2"
                                                                  }),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "color-secondary-6 font-14"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Razón: "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass: "p-3"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "info-panel-item"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "font-weight-normal ml-2 pl-1"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            historyItem.reasonComment
                                                                          ) +
                                                                          " "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-content-center mb-3"
                                      },
                                      [
                                        item.statusHistory.length >
                                        item.historySize
                                          ? _c(
                                              "action-button",
                                              {
                                                attrs: {
                                                  type: "button",
                                                  variant: "outline-success"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    item.historySize += 5
                                                  }
                                                }
                                              },
                                              [_vm._v(" Ver más ")]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-md-3 mt-2 border-right d-flex flex-column justify-content-center align-items-center"
                      },
                      [
                        _c("custom-balloon", {
                          staticClass:
                            "w-80 mt-2 mx-md-3 font-weight-bold font-16",
                          attrs: {
                            "background-color": `bg-${_vm.getStatusColor(
                              item.statusId
                            )}`,
                            text: item.statusName
                          }
                        }),
                        _c("div", { staticClass: "ml-4 mt-3 text-center" }, [
                          _c("div", { staticClass: "data-name" }, [
                            _vm._v("Fecha de Solicitud:")
                          ]),
                          _c("label", { staticClass: "data ml-n3" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("date")(item.dispenseRequestDate)
                                ) +
                                " "
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "ml-4 text-center" }, [
                          _c("div", { staticClass: "data-name" }, [
                            _vm._v("Número de Dispensa:")
                          ]),
                          _c("label", { staticClass: "data" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("empty")(item.exemptionDprNumber)
                                ) +
                                " "
                            )
                          ])
                        ])
                      ],
                      1
                    ),
                    _c("div", { staticClass: "col-md-7 py-3 px-4" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "data-name" }, [
                            _vm._v("Fecha Desde:")
                          ]),
                          _c("span", { staticClass: "data" }, [
                            _vm._v(
                              _vm._s(_vm._f("date")(item.dispenseStartDate))
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "data-name" }, [
                            _vm._v("Fecha Hasta:")
                          ]),
                          _c("span", { staticClass: "data" }, [
                            _vm._v(_vm._s(_vm._f("date")(item.dispenseEndDate)))
                          ])
                        ]),
                        item.exemptionType !=
                        _vm.exemptionTypes.EspecialistaDEPR
                          ? _c("div", { staticClass: "col-md-4 text-center" }, [
                              _c("div", { staticClass: "data-name" }, [
                                _vm._v("Supervisados en Corporación:")
                              ]),
                              _c("span", { staticClass: "data" }, [
                                _vm._v(_vm._s(item.dispenseDetailCount))
                              ])
                            ])
                          : _vm._e()
                      ]),
                      _c("div", { staticClass: "row mt-3" }, [
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "data-name" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  `Especialista${
                                    item.exemptionType ==
                                    _vm.exemptionTypes.EspecialistaDEPR
                                      ? ""
                                      : " Supervisor"
                                  }:`
                                ) +
                                " "
                            )
                          ]),
                          _c("span", { staticClass: "data" }, [
                            _vm._v(_vm._s(item.specialistName))
                          ])
                        ]),
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "data-name" }, [
                            _vm._v("Proveedor:")
                          ]),
                          _c("span", { staticClass: "data" }, [
                            _vm._v(_vm._s(item.companyName))
                          ])
                        ]),
                        item.exemptionType !=
                        _vm.exemptionTypes.EspecialistaDEPR
                          ? _c("div", { staticClass: "col-md-4 text-center" }, [
                              _c("div", { staticClass: "data-name" }, [
                                _vm._v(" Supervisados en Otras Corporaciones: ")
                              ]),
                              _c("span", { staticClass: "data" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.dispenseDetailOtherCompaniesCount
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-md-2 text-right pr-5" },
                      [
                        _c("drop-down", {
                          attrs: {
                            "data-item": { item, index },
                            items: _vm.actionItems(item)
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }